export default {
  SORT_ICON: (columnTestId: string) => `${columnTestId}-sort-icon`,
  LABEL_CONTAINER: (columnTestId: string) => `${columnTestId}-label-container`,
};
